import React, { useState } from 'react';
import { FC, ReactNode } from 'react';
import { CircularProgress } from '@mui/material';
import cn from 'classnames';
import styles from './button.module.scss';

export enum ButtonVariant {
  UNDERLINED = 'underlined',
  CONTAINED = 'contained',
  OUTLINED = 'outlined',
}

export const Button: FC<{
  children: ReactNode;
  onClick: () => void | Promise<void>;
  type?: ButtonVariant;
  style?: React.CSSProperties;
  isDisabled?: boolean;
}> = ({children, type = ButtonVariant.UNDERLINED, style, onClick, isDisabled = false}) => {
  const [isAwaitingCallback, setIsAwaitingCallback] = useState(false);

  const handleClick = async () => {
    try {
      if (!isAwaitingCallback && !isDisabled) {
        setIsAwaitingCallback(true);
        await onClick();
        setIsAwaitingCallback(false);
      }
    } catch (error) {
      setIsAwaitingCallback(false);
    }
  };

  return (
    <button
      className={cn(styles.button, {
        [styles.underlinedButton]: type === ButtonVariant.UNDERLINED,
        [styles.containedButton]: type === ButtonVariant.CONTAINED,
        [styles.outlinedButton]: type === ButtonVariant.OUTLINED,
      })}
      style={style ?? {}}
      disabled={isDisabled}
      onClick={handleClick}
    >
      <span>{isAwaitingCallback ? <CircularProgress color="inherit" size={14} /> : null}</span>

      {children}
    </button>
  );
};
